import { QuizQuestionFragment } from '@vangst/services/oogst/types'
import { useFormContext } from 'react-hook-form'
import Checkbox from '../../components/forms/Checkbox'
import ControlGroup from '../../components/forms/ControlGroup'
import Radio from '../../components/forms/Radio'
import validations from '../application/validations'

type PropsType = React.InputHTMLAttributes<
  HTMLInputElement | HTMLLabelElement
> & {
  quizQuestion: QuizQuestionFragment
  name: string
}

export default function CourseQuestion(props: PropsType) {
  const { quizQuestion, name } = props

  const methods = useFormContext()
  const { ref, ...formProps } = methods.register(name, validations.generic)
  const isMultiChoice = quizQuestion.question.questionAnswerType === 'CHECKBOX'
  return (
    <ControlGroup
      error={methods.formState.errors?.[name]?.message}
      label={quizQuestion.question.value}
      hideLabel
      name={name}
      required
      type={!isMultiChoice ? 'radio' : 'checkbox'}
    >
      {isMultiChoice && (
        <span className="text-sm">(choose all that apply)</span>
      )}
      {quizQuestion.questionAnswers.map((answer, i) => {
        return !isMultiChoice ? (
          <Radio
            className="mt-1"
            classNameLabel="items-start"
            key={i}
            label={answer.answer}
            reference={ref}
            value={answer.id}
            {...formProps}
          />
        ) : (
          <Checkbox
            id={answer.id}
            label={answer.answer}
            reference={ref}
            value={answer.id}
            {...formProps}
          />
        )
      })}
    </ControlGroup>
  )
}
